export interface CdnUploadPolicy {
  url: string;
  fields: Record<string, string>;
  method?: string;
  max_size?: number;
  file_name: string;
  is_private?: boolean;
  cdn_pat?: string;
  expires?: number;
}

export async function uploadFileWithPolicy(policy: CdnUploadPolicy, file: File | Blob): Promise<Response> {
  const formData = new FormData();
  Object.entries(policy.fields || {}).forEach(([key, value]) => {
    formData.append(key, value as string);
  });
  formData.append('file', file);

  const response = await fetch(policy.url, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Upload failed (${response.status}). The file may exceed your plan's size limit.`);
  }

  return response;
}
